import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-area-charts-page-ui',
    templateUrl: './bb-area-charts-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbAreaChartsPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
